import { createStorage } from "shared/lib/storage/storage";

const local = createStorage("local");

const ACCESS_TOKEN_KEY = "accessToken";
const REFRESH_TOKEN_KEY = "refreshToken";
const TOKEN_TYPE_KEY = "tokenType";

export const tokenStorage = {
  getAccessToken: () => local.get(ACCESS_TOKEN_KEY),
  getRefreshToken: () => local.get(REFRESH_TOKEN_KEY),
  getTokenType: () => local.get(TOKEN_TYPE_KEY) || "Bearer",

  setAccessToken: (accessToken) => {
    if (!accessToken) throw new Error("Invalid access token");
    local.set(ACCESS_TOKEN_KEY, accessToken);
  },

  setRefreshToken: (refreshToken) => {
    if (!refreshToken) throw new Error("Invalid refresh token");
    local.set(REFRESH_TOKEN_KEY, refreshToken);
  },

  setTokenType: (tokenType) => {
    if (!tokenType) throw new Error("Invalid token type");
    local.set(TOKEN_TYPE_KEY, tokenType);
  },

  setTokens: ({ accessToken, refreshToken, tokenType }) => {
    if (!accessToken || !refreshToken || !tokenType) {
      throw new Error("Invalid token payload");
    }

    local.set(ACCESS_TOKEN_KEY, accessToken);
    local.set(REFRESH_TOKEN_KEY, refreshToken);
    local.set(TOKEN_TYPE_KEY, tokenType);
  },

  clearTokens: () => {
    local.remove(ACCESS_TOKEN_KEY);
    local.remove(REFRESH_TOKEN_KEY);
    local.remove(TOKEN_TYPE_KEY);
  },
};
